import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import React, { ReactNode } from 'react'
import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { getDataUserSso } from '../../services/auth'
import { saveLocationToStorage } from '../../utils/localStorageHelper'
import { useStyles } from './styles'

export default function PlatformRouteSwitcher({
  children,
}: {
  children: ReactNode
}) {
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()
  const urlParams = new URLSearchParams(location.search)
  const token = urlParams.get('token')
  const [loading, setLoading] = useState<boolean>(false)

  function handleRedirect() {
    history.push({
      pathname: location.pathname,
      state: 'mobile',
    })
  }

  async function fetchUsersData() {
    saveLocationToStorage('@current-mobile-view', {
      mobile: 'true',
    })
    try {
      setLoading(true)
      const { data: user } = await getDataUserSso(token)

      if (user?.length > 0 && token) {
        document.cookie = `gov_access_token_sso=${token}; path=/`
        document.cookie = `gov_user_data=${encodeURIComponent(
          JSON.stringify(user[0]),
        )}; path=/`
        handleRedirect()
      }
    } catch (error) {
      history.push('/invalid')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (token) {
      fetchUsersData()
    }
  }, [token])

  if (loading) {
    return (
      <Box className={classes.contentLoading}>
        <CircularProgress size={40} />
      </Box>
    )
  }

  return <>{children}</>
}
